import { useAtomValue } from 'jotai/utils';
import { addonsSettingsAtom } from 'src/shared/settings/addons';

/**
 * Whether the AI Image Edit addon is enabled for the current user.
 *
 * AI Image Edit is a per-user addon that defaults to disabled and is
 * granted by an admin (it is NOT always-on). The action is only surfaced
 * in the assets UI (list rows, gallery cards, detail view) when the user
 * has the addon both added AND enabled. The account master switch
 * (`ai_settings.image_edit_enabled`) is enforced server-side — the
 * settings endpoint that exposes it is admin-only, so the UI gates on the
 * per-user grant, which every user can read from their own settings.
 */
export function useImageEditAvailable(): boolean {
  const addonsSettings = useAtomValue(addonsSettingsAtom);
  return Boolean(
    addonsSettings?.AI_IMAGE_EDIT?.added && addonsSettings?.AI_IMAGE_EDIT?.enabled,
  );
}
